import { ESCALATION_CATEGORY_INFO } from "@/lib/categoryInfo";

export function MyScenariosTab({ scenarios }) {
  return (
    <div className="space-y-4">
      {scenarios.length === 0 && <p className="text-zinc-500 text-center py-10">You haven't shared any scenarios yet.</p>}
      {scenarios.map((s) => (
        <div key={s.id} className="bg-white border border-zinc-200 rounded-sm p-5">
          <span className={`inline-block mb-2 px-2 py-0.5 rounded-full text-xs font-bold uppercase border ${ESCALATION_CATEGORY_INFO[s.category]?.color}`}>
            {ESCALATION_CATEGORY_INFO[s.category]?.label}
          </span>
          <h3 className="font-display font-semibold text-zinc-950 mb-1">{s.title}</h3>
          <p className="text-zinc-500 text-xs">{s.votes_bias} said bias · {s.votes_not_bias} said not bias</p>
        </div>
      ))}
    </div>
  );
}
